import { useEffect } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { userConfig } from '../api';
import { featureHubState } from '../store/feature-atoms';
import { whiteLabelThemeConfigState } from '../store/whitelabel-theme-settings';
import { FEATURE_FLAGS } from '../constants/feature-flags';
import * as WL from '../constants/white-label-config';
import { isEmbedded } from '../utilities/router-utils';
import { safeJsonParse } from '../utilities/general';

export const setArgosParams = ({ /* user, customer, */ flags }) => {
  try {
    if (flags?.[FEATURE_FLAGS.NC_CONFIG]) {
      window.argosParams[FEATURE_FLAGS.NC_CONFIG] = safeJsonParse(flags?.[FEATURE_FLAGS.NC_CONFIG]);
    }
    if (flags?.[FEATURE_FLAGS.OLH_VERSION]) {
      window.argosParams[FEATURE_FLAGS.OLH_VERSION] = flags?.[FEATURE_FLAGS.OLH_VERSION];
    }
    if (flags?.[FEATURE_FLAGS.LANGUAGE_SWITCHER_VISIBILITY]) {
      window.argosParams[FEATURE_FLAGS.LANGUAGE_SWITCHER_VISIBILITY] = true;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Failed to parse argosParams', e);
  }
};

export const useFeatureHub = () => {
  const [data, setData] = useAtom(featureHubState);
  const setTheme = useSetAtom(whiteLabelThemeConfigState);

  const tempSetW = () => {
    /** TODO delete me after we finish with EM mode */
    const subdomain = WL.getSubdomainForEnv();
    if (subdomain === WL.MAIN_BRAND_NAME || isEmbedded /* Consider CP theme/WL-Config in case of embed mode */) {
      // if it's our tenant, no need to waste time on fetching WL configuration.
      setTheme(WL.whiteLabelCompanyConfig());
    }
  };

  const fetchFeatureHub = async () => {
    setData(prev => ({ ...prev, isLoading: true }));
    try {
      const response = await userConfig.fetchFeatureHub();
      const featureFlags = response.data.data.feature_flags;
      setData(prev => ({ ...prev, featureFlags, loaded: true, isLoading: false }));

      setArgosParams({ flags: featureFlags });
      tempSetW();
    } catch (error) {
      setData(prev => ({ ...prev, error: true, isLoading: false }));
    }
  };

  useEffect(() => {
    // Only fetch if not already loading or loaded
    if (!data.isLoading && !data.loaded && !data.error) {
      fetchFeatureHub();
    }
  }, []);

  return {
    flags: data.featureFlags,
    isLoading: data.isLoading,
    loaded: data.loaded,
    refetch: fetchFeatureHub
  };
};

export const useFeatureHubData = () => {
  const data = useAtomValue(featureHubState);

  return {
    flags: data.featureFlags,
    isLoading: data.isLoading,
    loaded: data.loaded,
    error: data.error
  };
};
